
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-mouse",
  "use": "icon-material-mouse-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-mouse\"><path d=\"M479.96-74.02q-120.59 0-203.26-82.67-82.68-82.66-82.68-203.31v-260q0-120.58 82.66-203.4t203.25-82.82 203.44 82.82T766.22-620v260q0 120.65-82.83 203.31-82.84 82.67-203.43 82.67M510-620h187.85q0-79.85-52.28-142.23-52.29-62.38-135.57-73.62zm-247.85 0H450v-215.85q-83.28 11.24-135.57 73.62-52.28 62.38-52.28 142.23m217.59 477.85q90.3 0 154.21-63.72 63.9-63.72 63.9-154.13v-200h-435.7v200q0 90.34 63.65 154.1 63.64 63.75 153.94 63.75M480-560\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-mouse"/>
                </svg>
            );
        };

        Icon.id = "icon-material-mouse";

        export default Icon;
    